export default __webpack_public_path__ + "static/media/image_brazil.d5d82bec.png";